export default __webpack_public_path__ + "static/media/1.355bee2e.jpg";